<template> 
    <div class="row"  v-if="model"> 
        <div class="col-12 col-sm-12 col-md-12 col-xl-12"> 
            <CardRh :processando="processando" :titulo="'Aluno: ' + model.matricula.usuario.nome" >  
                <br>
                <div class="row g-6 g-xl-12">  
                    <div class="row">   
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-8 text-center">
                            <button class="btn btn-flex btn-secondary px-6 btn-flex-full"> 
                                <span class="menu-icon">
                                    <i class="fas fa-graduation-cap fa-2x bi fs-2x text-info" ></i> 
                                </span>
                                <span class="d-flex flex-column align-items-start ms-2">
                                    <span class="fs-3 fw-bolder">Disciplina</span>
                                    <span class="fs-5">{{ model.disciplina.descricao}}</span>
                                </span>
                            </button>
                        </div> 
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 text-center">
                            <button class="btn btn-flex btn-secondary px-6 btn-flex-full"> 
                                <span class="menu-icon">
                                    <i class="fas fa-user-tie fa-2x bi fs-2x text-info" ></i> 
                                </span>
                                <span class="d-flex flex-column align-items-start ms-2">
                                    <span class="fs-3 fw-bolder">Nota</span>
                                    <span class="fs-5">{{model.notaValor}}</span>
                                </span>
                            </button>
                        </div>   
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-8 text-center">
                            <button  class="btn btn-flex btn-secondary px-6 btn-flex-full"> 
                                <span class="menu-icon">
                                    <i class="fas fa-comment fa-2x bi fs-2x text-info" ></i> 
                                </span>
                                <span class="d-flex flex-column align-items-start ms-2">
                                    <span class="fs-3 fw-bolder">Turma</span>
                                    <span class="fs-7">{{model.disciplina.turma.descricao}}</span>
                                </span>
                            </button>
                        </div> 
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 text-center">
                            <button class="btn btn-flex btn-secondary px-6 btn-flex-full"> 
                                <span class="menu-icon">
                                    <i class="fas fa-arrows-spin fa-2x bi fs-2x text-info" ></i> 
                                    <i class="fa-solid "></i>
                                </span>
                                <span class="d-flex flex-column align-items-start ms-2">
                                    <span class="fs-3 fw-bolder">Forma de Avaliação</span>
                                    <span class="fs-7">{{model.disciplina.tipo.nome}}</span>
                                </span>
                            </button>
                        </div>  
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 text-center">
                            <button class="btn btn-flex btn-secondary px-6 btn-flex-full"> 
                                <span class="menu-icon">
                                    <i class="fas fa-hashtag fa-2x bi fs-2x text-info" ></i> 
                                </span>
                                <span class="d-flex flex-column align-items-start ms-2">
                                    <span class="fs-3 fw-bolder">Prova</span>
                                    <span class="fs-7">{{model.tipo.nome}}</span>
                                </span>
                            </button>
                        </div>  
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 text-center">
                            <button class="btn btn-flex btn-secondary px-6 btn-flex-full"> 
                                <span class="menu-icon">
                                    <i class="fas fa-arrows-spin fa-2x bi fs-2x text-info" ></i>  
                                </span>
                                <span class="d-flex flex-column align-items-start ms-2">
                                    <span class="fs-3 fw-bolder">Status</span> 
                                    <span class="fs-7">{{model.status.nome}}</span>
                                </span>
                            </button>
                        </div>    
                        <div class="col-12 col-sm-6 col-md-6 col-xxl-4" v-if="hasPermissaoEditar">  
                            <button class="btn btn-flex btn-secondary px-6 me-5 btn-flex-full" btn-set-rota data-bs-toggle="modal" :data-bs-target="'#'+ modal ">  
                                <span class="menu-icon">
                                    <i class="fas fa-edit fa-2x bi fs-2x text-pmes-primary" ></i> 
                                </span>
                                <span class="d-flex flex-column align-items-start ms-2">
                                    <span class="fs-3 fw-bolder">Editar</span> 
                                    <span class="fs-7">Nota</span> 
                                </span> 
                            </button> 
                            <Editar @update-nota-alterado="modeloAlterado" :modelo="model" :modal="modal" v-if="hasPermissaoEditar" :perfis="perfis"/>  
                        </div>  
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 text-center" v-if="hasPermissaoEditar">
                            <button  @click="excluirModelo" class="btn btn-flex btn-secondary px-6 btn-flex-full border border-danger  border-dashed"> 
                                <span class="menu-icon">
                                    <i class="fas fa-trash fa-2x bi fs-2x text-danger" ></i>  
                                </span>
                                <span class="d-flex flex-column align-items-start ms-2">
                                    <span class="fs-3 fw-bolder">Excluir</span> 
                                    <span class="fs-7">Nota</span>
                                </span>
                            </button>
                        </div>   
                    </div>  
                </div>   
            </CardRh> 
            <br> 
        </div> 
        <!-- <div class="col-12 col-sm-12 col-md-12 col-xl-4"> 
            <CardRh titulo="Historico">  
                <div v-for="p in model.situacoes" :key="p.id" class="me-5">  
                     <div class=" alert alert-dismissible bg-light-primary border border-primary border-2 border-dashed d-flex flex-column flex-sm-row w-100 p-5 mb-10 position-relative me-5  " >
                        <span class="svg-icon svg-icon-2hx svg-icon-primary me-4 mb-5 mb-sm-0" >  
                            <i class="fas fa-lock bi fs-2x" v-if="p.nota_status_atual === 1"></i> 
                            <i class="fas fa-user-edit bi fs-2x" v-if="p.nota_status_atual === 2"></i>
                            <i class="fas fa-pray bi fs-2x" v-if="p.nota_status_atual === 3"></i>
                            <i class="fas fa-inbox bi fs-2x" v-if="p.nota_status_atual === 4"></i> 
                            <i class="fas fa-trash-alt bi fs-2x" v-if="p.nota_status_atual === 5"></i> 
                        </span>  
                        <div class="d-flex flex-column pe-0 pe-sm-10 " >
                            <h6 class="mb-1"> {{p.status_atual}}</h6> 
                            <span>Nota: {{p.nota}}</span> 
                        </div> 
                        <span class="position-absolute top-0 start-90 translate-middle  badge  badge-danger">{{ p.created_at }}</span>
                        <span class="position-absolute top-100 start-90 translate-middle  badge  badge-secondary">{{p.updated_user}}</span>
                    </div> 
                </div>
                <div>
                    <i class="fas fa-clock bg-gray fs-2x"></i>
                </div> 
            </CardRh> 
        </div>  -->
    </div>   
</template>

<script lang="ts">   
    import CardRh from   "@/components/cards/ManzaCard.vue"
    import NotaService from   "@/service/v1/sigap/NotaService"  
    import { Options, Vue  } from "vue-class-component";    
    import   SiteUtils   from '@/assets/ts/aplicacao/site'; 
    import KDataTable from   "@/components/datatable/newdatatable.vue"  
    import { PerfilConfig } from "@/core/config/PerfisConfig"; 
    import Editar from   "./_Editar.vue"   
      
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth'); 

    @Options({
        name: "NotaShow",
        components: {  CardRh , KDataTable , Editar },   
    }) 
    export default class NotaShow extends Vue {
        
        @authStore.Getter
		public perfis!: any  

        @authStore.Getter
		public token!: any 
  
        public service = new NotaService(); 
        public model: any = null ;
        public turma: any = null ;
        public processando = false ; 
        public modal = 'modal_alterar_disciplina' ;
         
        get hasPermissao( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE , PerfilConfig.LeituraDE ] ,  this.perfis); 
        }
 
        get hasPermissaoEditar( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE ] ,  this.perfis); 
        }
  
        created(){
            this.buscaNota();  
        }

        public statusAlterado(dados){ 
            this.buscaNota() ;
        }

        public modeloAlterado( ){ 
            this.buscaNota() ;
        }

        public buscaNota(){   
            this.processando = true ; 
            this.service.getModel( this.$route.params.id  ) 
            .then(response => {   
                this.model =  JSON.parse(JSON.stringify( response ));   
                this.processando = false ;    
            })
            .catch(error => { 
                this.processando = false ; 
            }); 
        } 
 
        public excluirModelo(   ) {  
            SiteUtils.alertConfimacao('Confirma a Exclusão ','' , 
                () => {  
                    this.processando = true;  
                    setTimeout(() => {
                            this.service.excluir(  this.model.id   )
                        .then(response => {     
                            SiteUtils.toastSucesso('Exclusao realizada com sucesso!!' ); 
                            this.processando = false;
                            this.$router.push({ name: "sigap_avaliacao"  })
                            // this.$router.go(-1);
                        })
                        .catch(error => { 
                            this.processando = false; 
                            SiteUtils.toastErro('Não foi possivel Excluir ' , error.data.message); 
                        });  
                    }, 10); 
                }
            );   
        }  
 
    } 
</script>

<style scoped> 
    .btn-sm{
        margin-left: 10px; 
    } 
    .registro-alteracao{
        text-align: right;
    }

    .start-90{
        left: 95% !important;
    }
    
    .col-12{
        margin-bottom: 25px;
    }

    .btn-flex-full{
        max-width: 100%;
        min-width: 100%;
    }

</style>